/* __next_internal_client_entry_do_not_use__ Check auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1774))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:58.922Z
 */ export var Check = createSVGIcon(/*#__PURE__*/ _jsx("path", {
    d: "M0.857178 14.6555L5.54403 20.6829C5.70169 20.8855 5.90285 21.0501 6.13265 21.1646C6.36244 21.2791 6.61502 21.3404 6.87172 21.3442C7.12842 21.348 7.38269 21.2941 7.61577 21.1865C7.84884 21.0788 8.05476 20.9202 8.21832 20.7223L23.1429 2.65546",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
}), "Check", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
